import { useNavigate } from "react-router-dom";
import usePageTitle from "../../core/hooks/UsePageTitle";
import { AuthCard } from "../components/AuthCard/AuthCard";

export default function PagamentoPendenteView() {
  usePageTitle("Pagamento pendente");

  const navigate = useNavigate();

  return (
    <AuthCard title="Pagamento">
      <div className="text-center py-4">
        <div className="text-5xl mb-5">⏳</div>
        <p className="text-slate-700 dark:text-slate-200 font-semibold text-lg mb-1">
          Pagamento em análise
        </p>
        <p className="text-sm text-slate-500 dark:text-slate-400 mb-7 leading-relaxed">
          Seu pagamento está sendo processado pelo MercadoPago. Assim que for
          confirmado, seu acesso será liberado automaticamente.
        </p>
        <button
          onClick={() => navigate("/home")}
          className="w-full py-2.5 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg transition-colors duration-200 mb-3"
        >
          Acessar plataforma
        </button>
        <button
          onClick={() => navigate("/planos")}
          className="w-full py-2.5 bg-slate-100 hover:bg-slate-200 text-slate-700 font-semibold rounded-lg transition-colors duration-200"
        >
          Ver planos
        </button>
      </div>
    </AuthCard>
  );
}
